// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__uHqOc","checkboxCol":"Table_checkboxCol__367AD","emailCol":"Table_emailCol__1eCpP","actionCol":"Table_actionCol__215mH"};